import { jsxs as _jsxs } from "react/jsx-runtime";
import { jsx as _jsx } from "react/jsx-runtime";
import PropTypes from 'prop-types';
import { PureComponent } from 'react';
import classNames from 'classnames';
import { isValidDomain } from '../validation/PropertyValidations';
import UILink from 'UIComponents/link/UILink';
import UIList from 'UIComponents/list/UIList';
import ValuePropType from '../utils/propTypes/ValuePropType';
export default class PropertyInputFiles extends PureComponent {
  getValue() {
    const urls = this.props.value ? this.props.value.split(/[;,]+/) : [];
    return urls.filter(url => isValidDomain(url.trim()));
  }

  render() {
    const className = classNames('p-left-0', this.props.className);
    return /*#__PURE__*/_jsx(UIList, {
      className: className,
      children: this.getValue().map(url => {
        const match = url.match(/\/([^/]*)$/);
        const fileName = match ? match[1] : '';
        return /*#__PURE__*/_jsxs(UILink, {
          href: url,
          external: true,
          children: [' ', fileName, ' ']
        }, url);
      })
    });
  }

}
PropertyInputFiles.propTypes = {
  value: ValuePropType,
  className: PropTypes.string
};